var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueRecaptcha',{staticClass:"mb-4",attrs:{"sitekey":"6Lf4suEUAAAAANoI6Wva8n37yfYOZa5RAuegEtRE","loadRecaptchaScript":true},on:{"verify":_vm.onCaptchaVerify,"expired":_vm.onCaptchaExpired}})}
var staticRenderFns = []

export { render, staticRenderFns }